export default {
    state :{
      isLogin:false,//登录组件是否显示
      isVip:false,//vip组件是否显示
      navSelect:1,//顶部菜单
      batchValue:"",
    },
    mutations :{
        SET_ISLOGIN: (state, isLogin) => {
            state.isLogin = isLogin
        },
        SET_NAV:(state,navSelect)=>{
          state.navSelect = navSelect
        },
        SET_ISVIP:(state,isVip)=>{
          state.isVip = isVip
        },
        SET_BATCH:(state,batchValue)=>{
          state.batchValue = batchValue
        }
    },
    actions :{
        set_isLogin({ commit }, isLogin) {
            commit('SET_ISLOGIN', isLogin)
        },
        set_isVip({ commit },isVip){
          commit("SET_ISVIP",isVip);
        },
        set_nav({commit},navSelect){
          commit("SET_NAV",navSelect)
        },
        set_batch({commit},batchValue){
          commit("SET_BATCH",batchValue)
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js